<template>
   <div 
                class="modal show" 
                id="cancelada" 
                tabindex="-1" 
                aria-labelledby="policies-modal" 
                aria-hidden="true">
               
                  <div class="modal-dialog modal-xl">
                    <div class="modal-content rounded-0">
                      <div 
                      class="modal-header rounded-0" 
                      style="background-color:#169a5a;">
                        <h5 class="modal-title modaltitle" id="policies-modal">{{$t('cancel.c8')}} {{ id }} {{$t('cancel.c9')}}</h5>
                        <button  type="button" class="close text-white" @click="salir">
                          <span aria-hidden="true">&times;</span>
                        </button>
                      </div>
                      <div class="modal-body">
                        <b-row>
                          <b-col md="12">
                            <p>{{$t('cancel.c8')}} {{$t('cancel.c9')}}</p>
                            
                            
                            <br>
                            <button class="btn btn-success float-right" type="button" @click="salir" style="border-radius:0px;">OK</button>
                            
                          </b-col>   
                          </b-row>
                      </div>
                    </div>
                  </div>
                </div>

</template>

<script>
    export default {
        props:['id'],
        methods: {
            salir() {
                location.replace('/')
            }
        },
    }
</script>

<style lang="scss" scoped>
@font-face {
    font-family: 'DIN 2014-ExraBold';
    src: url('../assets/fonts/DIN2014-ExtraBold.ttf');

}
@font-face {
    font-family: 'DIN 2014-Regular';
    src: url('../assets/fonts/DIN2014-Regular.ttf');
}
.modaltitle{
    font-family: 'DIN 2014-Regular';
    color: white;
}
</style>